import{IconCheckmark200 as e}from"../src/elements/IconCheckmark200.js";customElements.define("sp-icon-checkmark200",e);
//# sourceMappingURL=sp-icon-checkmark200.js.map
